import React from 'react';
import { cn } from '../../cn';

// Form wrapper
export const Form: React.FC<React.FormHTMLAttributes<HTMLFormElement>> = ({ 
  children, 
  className, 
  ...props 
}) => (
  <form className={cn('mt-6', className)} {...props}>
    {children}
  </form>
);

// Form item group
export const FormItemGroup: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ 
  children, 
  className, 
  ...props 
}) => (
  <div className={cn('space-y-1.5', className)} {...props}>
    {children}
  </div>
);

// Form label
export const FormLabel: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({ 
  children, 
  className, 
  ...props 
}) => (
  <label 
    className={cn(
      'block text-sm font-medium text-gray-700 dark:text-gray-300',
      className
    )} 
    {...props}
  >
    {children}
  </label>
);

// Form input
export const FormInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({ 
  className, 
  ...props 
}) => (
  <input
    className={cn(
      'block w-full rounded-md border border-gray-300 px-3 py-2 text-sm',
      'bg-white text-gray-900 placeholder-gray-500',
      'focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      'dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400',
      'dark:focus:border-blue-400 dark:focus:ring-blue-400',
      className
    )}
    {...props}
  />
);

// Form textarea
export const FormTextarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({ 
  className, 
  ...props 
}) => (
  <textarea
    className={cn(
      'block w-full rounded-md border border-gray-300 px-3 py-2 text-sm',
      'bg-white text-gray-900 placeholder-gray-500',
      'focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      'dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400',
      'dark:focus:border-blue-400 dark:focus:ring-blue-400',
      'resize-vertical',
      className
    )}
    {...props}
  />
);

// Form error
export const FormError: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ 
  children, 
  className, 
  ...props 
}) => (
  <div 
    className={cn(
      'text-sm font-medium text-red-600 dark:text-red-400',
      className
    )} 
    {...props}
  >
    {children}
  </div>
);

// Submit button
export const SubmitButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ 
  children, 
  className, 
  ...props 
}) => (
  <button
    type="submit"
    className={cn(
      'flex w-full justify-center rounded-md border border-transparent',
      'bg-blue-600 px-4 py-2 text-sm font-semibold text-white',
      'hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      'dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-400',
      className
    )}
    {...props}
  >
    {children}
  </button>
);
